import { Edition } from '@atlassian/touchpoint-commons-event-analytics';

import type { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'addPaymentDetails',
	dialogId: 'reverse-trial-popup',
	dialogType: 'pop-up',
	targetProductEdition: Edition.PREMIUM_EDITION,
};
